import { useBetAmountInputButtons } from '@/hooks/useBetAmountInputButtons';
import { BetAmountInputButtonsProps } from '../props';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { SettingLayoutComponentId } from '@starsoft/common/models';

export default function BetAmountInputButtonsV1({
  bet,
  version,
  isLoading,
}: BetAmountInputButtonsProps) {
  const { t } = useTranslation('common');
  const { handleDoubleAmount, handleHalfAmount, setMaxAmount, isDisabled } =
    useBetAmountInputButtons(bet);

  const Skeletons: JSX.Element[] = useMemo(
    () =>
      Array.from({ length: 3 }).map((_, i) => (
        <div
          key={`bet-amount-input-skeleton-button-${i}`}
          className={styles.skeleton}
        />
      )),
    [],
  );

  return (
    <div
      className={`${styles.container} ${version === SettingLayoutComponentId.BetAmountInputV2 ? styles['container--bordeless'] : ''}`}
    >
      {isLoading ? (
        Skeletons
      ) : (
        <>
          <button
            className={`${styles.container__button}`}
            disabled={isDisabled}
            onClick={handleHalfAmount}
          >
            ½
          </button>
          <button
            className={`${styles.container__button}`}
            disabled={isDisabled}
            onClick={handleDoubleAmount}
          >
            2x
          </button>
          <button
            className={`${styles.container__button}`}
            disabled={isDisabled}
            onClick={setMaxAmount}
          >
            {t('max_label')}
          </button>
        </>
      )}
    </div>
  );
}
